import React from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="tech-leaders-process">
                <div className="tech-leaders-process__wrapper">
                    <div className="tech-leaders-process__text-container">
                        <CommonTitle className="tech-leaders-process__title">Процесс</CommonTitle>
                        <CommonSmallTitle className="tech-leaders-process__subtitle">
                            Прототипирование
                        </CommonSmallTitle>
                        <CommonSmallText isOneParagraph="false">
                            Основным вызовом в прототипировании была сетка программы. Команда
                            столкнулось с целым рядом сложностей. Во-первых, сетка мероприятия очень
                            неоднородна: от крупных пленарных заседаний до небольших мероприятий
                            с разной длительность. Во-вторых, выступления в рамках конференции
                            проходили одновременно в 18 залах. Это не считая нескольких выставочных
                            зон, зон награждения и медиацентров. Все зоны и мероприятия
                            нужно было продумать, упростить и отразить в адаптивной сетке
                            для десктопа и мобайла.
                        </CommonSmallText>
                        <CommonSmallText isOneParagraph="false"></CommonSmallText>
                    </div>
                    <div className="tech-leaders-process__img">
                        <img
                            src="/images/svg/tech-leaders/tech-leaders-process__img.svg"
                            alt=""
                            loading="lazy"
                        />
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
